import { connect } from 'react-redux';
import { RootAction, State } from 'store/state';
import { validTabuByDocIdSelector, tabuByDocIdVariablesSelector } from 'store/state/domainData/selectors/tabuByDocId';
import { tabuAddressDetailsSelector, tabuStateSelector } from './selectors';
import { TabuProps, TabuWidget } from './Tabu';
import { Dispatch } from 'redux';
import { fetchMore as fetchMoreAction } from 'store/state/domainData/actions';
import { LoadType } from 'store/sagas/apiService/types';
import { ITabuByDocIdVariables } from 'utils/entities';
import { requestTabuByDocId, setTabuState } from 'store/state/app/actions';
import withEvents from 'analytics/withEvents';
import { setTabuSubmitted as setTabuSubmittedAction } from 'store/state/insightsContext/actions';
import { isTabuWizardDialogOpenSelector, routeSelector, DialogWithURLType, TabuDialogMeta, prevRouteSelector } from 'store/state/selectors/router';
import { navigateTo } from 'store/state/router/actions';
import { DecodedRouteParams } from 'config/routes';
import { NavigationOptions } from 'store/state/router/actionPayloads';


const TabuWidgetWithEvents = withEvents<TabuProps>((sendEvent, { source }) => ({
  setTabuSubmitted: () => sendEvent('tabu_check_availability_click', 'tabu', {
    event: {
      source,
      is_retry: false,
    },
  }),
  tabuFoundEvent: () => sendEvent('tabu_send_to_mail_click', 'tabu', {
    event: {
      source,
    },
  }),
  fetchMore: () => sendEvent('tabu_check_availability_click', 'tabu', {
    event: {
      source,
      is_retry: true,
    },
  }),
}))(TabuWidget);

const mapStateToProps = (state: State) => ({
  tabu: validTabuByDocIdSelector(state),
  route: routeSelector(state),
  prevRoute: prevRouteSelector(state),
  isTabuWizardOpen: isTabuWizardDialogOpenSelector(state),
  tabuVariables: tabuByDocIdVariablesSelector(state),
  addressDetails: tabuAddressDetailsSelector(state),
  tabuState: tabuStateSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  navigateTo: (...arg: [string, Record<string, any>, NavigationOptions]) => dispatch(navigateTo(...arg)),
  requestTabu: () => dispatch(requestTabuByDocId()),
  setSent: (isSent: boolean, docId: string) => dispatch(setTabuState({ [docId]: { isSent } })),
  setTabuSubmitted: (tabuSubmitted: boolean) => dispatch(setTabuSubmittedAction(tabuSubmitted)),
  fetchMore: (variables: ITabuByDocIdVariables) => dispatch(fetchMoreAction({
    loadType: LoadType.Tabu,
    meta: {
      variables,
    },
  })),
});


export type SetTabuWizardOpen = (state: boolean, meta: TabuDialogMeta) => void;

export default connect(mapStateToProps, mapDispatchToProps, ({ tabuVariables, route, prevRoute, ...stateProps }, { fetchMore, navigateTo: nav, ...dispatchProps }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  setTabuWizardOpen: (val: boolean, meta: TabuDialogMeta) => {
    if (!val && prevRoute) {
      window.history.back();
      return;
    }

    const params: DecodedRouteParams = {
      ...route.params,
      dialog: val ? { type: DialogWithURLType.TabuWizard, meta } : undefined,
    };
    nav(route.name, params, { replace: false });
  },
  reFetchTabu: () => {
    fetchMore(tabuVariables);
  },
}))(TabuWidgetWithEvents);
